import React, { useEffect, useState } from 'react';
import { Card, Button, Tabs, Tab} from 'react-bootstrap';
import { useParams, useHistory } from "react-router-dom";
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';

import { toast } from 'react-toastify';

import './EventSingle.scss';

import EventGeneral from './EventGeneral/EventGeneral';
import EventResources from './EventResources/EventResources';
import EventGuests from './EventGuests/EventGuests';
import EventResourceGuests from './EventResourceGuests/EventResourceGuests';
import EventInvoicing from './EventInvoicing/EventInvoicing';

function EventSingle() {

    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const history = useHistory();

    let { id } = useParams();
    const [forceUpdate, setForceUpdate] = useState(0);
    const [forceUpdateEvent, setForceUpdateEvent] = useState(0);

    const [allEvents, setAllEvents] = useState<Array<Object>>([]);
    const [allResources, setAllResources] = useState<Array<Object>>([]);
    const [allResourceTypes, setAllResourceTypes] = useState<Array<Object>>([]);
    const [allDeals, setAllDeals] = useState<Array<Object>>([]);
    
    const [event, setEvent] = useState<any>({});
    const [allBookings, setAllBookings] = useState<any>([]);
    const [guests, setGuests] = useState<any>([]);
    const [allCustomers, setAllCustomers] = useState<any>([]);
    const [tabKey, setTabKey] = useState<any>("general_info");

    const [people, setPeople] = useState<Array<Object>>([]);

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    function getPriceAndUnit(resource, selectedDeal) {
        let output = {unit: "", price: ""};

        function getPriceByUnit(priceList, unit) {
            if (unit == "") {
                return priceList[0].price;
            } else {
                return priceList.find(p => p.unit == unit)?.price ?? priceList[0].price;
            }
        }

        let exactPrices: Array<any> = [];
        let subcatPrices: Array<any> = [];
        let catPrices: Array<any> = [];

        if (selectedDeal != undefined ){
            exactPrices = selectedDeal["priceList"].filter(i => i.resource == resource.resource);
            subcatPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            catPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
        }

        if (exactPrices.length > 0) {
                output.price = getPriceByUnit(exactPrices, resource.unit);
                output.unit = exactPrices[0].unit;
        } else if (subcatPrices.length > 0) {
                output.price = getPriceByUnit(subcatPrices, resource.unit);
                output.unit = subcatPrices[0].unit;
        } else if (catPrices.length > 0) {
                output.price = getPriceByUnit(catPrices, resource.unit);
                output.unit = catPrices[0].unit;
        } else {
            let defaultDeal = allDeals.find(item => item["isDefaultDeal"] != false) || { priceList: [] };

            let exactPricesDefaultDeal = defaultDeal["priceList"].filter(i => i["resource"] == resource.resource);
            let subcatPricesDefaultDeal = defaultDeal["priceList"].filter(i => i["resourceType"] == resource.resourceType && i["resourceSubtype"] == resource.resourceSubtype && i["resource"] == "");
            let catPricesDefaultDeal = defaultDeal["priceList"].filter(i => i["resourceType"] == resource.resourceType && i["resourceSubtype"] == "");
            
            if (exactPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(exactPricesDefaultDeal, resource.unit);
                output.unit = exactPricesDefaultDeal[0].unit;
            } else if (subcatPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(subcatPricesDefaultDeal, resource.unit);
                output.unit = subcatPricesDefaultDeal[0].unit;
            } else if (catPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(catPricesDefaultDeal, resource.unit);
                output.unit = catPricesDefaultDeal[0].unit;
            }
        }

        return output;
    }

    function handleSave(saveBookings = true){

        if (event._id == undefined || event._id == "") {
            handleSaveNew();
        } else {
            if(saveBookings){
                handleSaveBookings();
            }
           
            handleSaveEdit();
            if(allResources != undefined && allResources.length > 0){
                handleSaveResource();
            }
        }
        
        localStorage.removeItem("editedItems");
        setForceUpdate(forceUpdate + 1);
    }

    const handleSaveEdit = () => {
        if (event["name"] == "" || event["name"] == undefined) { notifyWarning(t("events.toast_Events_empty_name")); return undefined; }
        if (event["periods"] == undefined) { notifyWarning(t("events.toast_Events_missing_periods")); return undefined; }
        if (event["periods"].length == 0) { notifyWarning(t("events.toast_Events_missing_periods")); return undefined; }
        if (event["periods"].some(p => p["from"] == undefined)) { notifyWarning(t("events.toast_Events_missing_period_from")); return undefined; }
        if (event["periods"].some(p => p["to"] == undefined)) { notifyWarning(t("events.toast_Events_missing_period_to")); return undefined; }
        axios.put('/api/events/' + id,
        {
            ...event
         }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            notifySuccess(t("events.toast_Event_saved"));
        });
    };

    const handleSaveNew = () => {
        if(allEvents.map(i=>i["name"]).includes(event.name) == true &&
        allEvents.map(pf=>pf["period_from"]).includes(event.period_from) == true &&
        allEvents.map(pt=>pt["periods_to"]).includes(event.period_to) == true)
        {notifyWarning(t("event.toast.event_already_exist")); return undefined; }

        if (event["name"] == "" || event["name"] == undefined) { notifyWarning(t("events.toast_Events_empty_name")); return undefined; }
        if (event["periods"] == undefined) { notifyWarning(t("events.toast_Events_missing_periods")); return undefined; }
        if (event["periods"].length == 0) { notifyWarning(t("events.toast_Events_missing_periods")); return undefined; }
        if (event["periods"].some(p => p["from"] == undefined)) { notifyWarning(t("events.toast_Events_missing_period_from")); return undefined; }
        if (event["periods"].some(p => p["to"] == undefined)) { notifyWarning(t("events.toast_Events_missing_period_to")); return undefined; }
        axios.post(
            "/api/Events",
            {
                ...event
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            setForceUpdate(forceUpdate + 1);
            fetchData();
            
            setEvent(res.data);
            history.push("/event/" + res.data._id);
            notifySuccess(t("events.toast_Events_created"));
            setTabKey("resources_info");
        });
    }

    const handleSaveResource = (resourceInArray = allResources) => {
        axios.put(
            '/api/resources/updatemany',
            {
                resources: resourceInArray.filter(x => x["changed"] == true).map(i => {
                    return {
                        _id: i["_id"],
                        bookings: i["bookings"]?.map(b => {
                            return {
                                ...b,
                                bookingtimes: b.bookingtimes != undefined ? b.bookingtimes.map(t => {
                                    return {
                                        ...t,
                                        //state: "reserved"
                                    }
                                }) : []
                            }
                        })
                    }
                })
            }, 
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(function (response) {
            notifySuccess(t("events.toast_resource_saved"));
        });
    }

    const handleSaveBookings = () => {
        let bookingsInArray = allBookings;

        for (let bookingInArray of bookingsInArray) {
            if (bookingInArray.resources == undefined || bookingInArray.resources.length == 0) {
                let selectedDeal = allDeals.find(item => item["_id"].toString() == bookingInArray.deal);

                bookingInArray.resources = [];
                let resources = allResources.filter(r => r["bookings"].map(b => b.bookingId).includes(bookingInArray._id.toString()));
                let bookingResources: Array<any> = [];

                for (let resource of resources) {

                    let tempBookingResource = {
                        resourceType: resource["resourceType"],
                        resourceSubtype: resource["resourceSubtype"],
                        resource: resource["_id"],
                        unit: "day",
                        price: ""
                    }
    
                    let prices = getPriceAndUnit(resource, selectedDeal);
                    tempBookingResource.price = prices.price;
                    tempBookingResource.unit = prices.unit;

                    bookingResources.push(tempBookingResource);
                }

                if (bookingResources.length > 0) { 
                    bookingInArray.resources = bookingResources;
                }
            }
        }

        axios.put(
            '/api/bookings/updatemany',
            {
                bookings: bookingsInArray.map(i => {
                    return {
                        ...i,
                        resources: i.resources != undefined ? i.resources.map(r => {
                            return {
                                ...r,
                            }
                        }) : []
                    }
                })
            }, 
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(function (res) {
            notifySuccess(t("events.toast_bookings_saved"));
        });
    }

    const handleSaveBooking = (booking) => {
        let tempBookings = allBookings.filter(b=>b._id != booking._id);
        tempBookings = [...tempBookings, booking]
        setAllBookings(tempBookings);

        axios.put( 
            '/api/bookings/' + booking._id,
            {...booking}, 
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(function (res){
            
        })
    }

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/events",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resourceTypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/bookings",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/persons/byBooking/byEvent/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/customers/",
                responsType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/persons",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/deals",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            setAllEvents(res[0]["data"]);
            setAllResources(res[1]["data"].sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0));
            setAllResourceTypes(res[2]["data"]);
            setAllBookings(res[3]["data"]);
            setAllCustomers(res[5]["data"]);
            setPeople(res[6]["data"]);
            setAllDeals(res[7]["data"]);

            fetchGuests();
        }))
        .catch(err => console.log(err));
    }

    function fetchGuests() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/persons/byBooking/byEvent/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            setGuests(JSON.parse(JSON.stringify(res[0]["data"])));
        }))
        .catch(err => console.log(err));
    }

    function fetchDataByEventId() {
        axios.single({
            method: "get",
            url: "/api/events/" + id,
            responseType: "json",
            headers: {'x-access-token': auth.user["token"]}
        })
        .then((res) => {
           setEvent(res.data);
           setForceUpdate(forceUpdate + 1);
        })
        .catch(err => console.log(err));
    }

    useEffect(() => {
        fetchData();
        if(id != undefined){
            fetchDataByEventId();
        }
    }, []);

    useEffect(() => {
        fetchData();
        if(id != undefined){
            fetchDataByEventId();
        }
    }, [forceUpdateEvent]);

    return (
        <div className="maincontent">
            <div className="myaccount-container">
                <div className="pagetitle-container">
                    <h1>{t("event.page_name")}: <strong>{event.name}</strong></h1>
                </div>
                <div className="col col-md-12">
                    <Card style={{ marginTop: "60px", borderTop: "1px solid #fcb85f" }}>
                        <Card.Body>
                            <Tabs 
                                className="no-print" 
                                style={{ marginTop: "-62px" }} 
                                activeKey={tabKey} 
                                id="general_info"
                                onSelect={(eventkey, evt) =>{ 
                                    setTabKey(eventkey);
                                    if(eventkey == "timeline_info" || eventkey == "resources_info"){
                                        setForceUpdate(forceUpdate + 1)
                                    }
                                }}
                            >
                                <Tab eventKey="general_info" title={t("event.general_information")} >
                                    <EventGeneral
                                        allEvents={allEvents}
                                        event={event}
                                        onChange={(changedEvent)=>setEvent(changedEvent)}
                                    ></EventGeneral>
                                    <br/>
                                </Tab>
                                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                    <Tab 
                                        eventKey="resources_info" 
                                        title={t("event.resources_information")}
                                        disabled={event._id == undefined || event._id == "" ? true : false}
                                    >
                                        <div style={{ marginTop: '20px' }}>
                                            <EventResources
                                                fetchDataPass={() => {
                                                    fetchData();
                                                    setForceUpdateEvent(forceUpdateEvent + 1);
                                                }}
                                                allResources={allResources}
                                                allResourceTypes={allResourceTypes}
                                                event={event}
                                                allCustomers={allCustomers}
                                                allBookings={allBookings}
                                                onChange={(changedResource)=>{
                                                    setForceUpdate(forceUpdate + 1);
                                                }}
                                                onResourcesChange={(resourcesChanged) => {
                                                    setAllResources(resourcesChanged);
                                                    setForceUpdate(forceUpdate + 1);
                                                }}
                                                forceUpdate={forceUpdate}
                                                resourcesInEvent={allResources.filter(r => ([].concat.apply([], r["bookings"].map(b => b?.eventId ?? "")) as Array<any>).includes(event._id?.toString()))}
                                            ></EventResources>
                                        </div>
                                        <br/>
                                    </Tab>
                                : null }
                                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                    <Tab
                                        eventKey="guests_info" 
                                        title={t("event.guests_information")} 
                                        disabled={event._id == undefined || event._id == "" ? true : false}
                                    >
                                        <EventGuests
                                            event={event}
                                            people={people}
                                            customers = {allCustomers}
                                            onGuestAdd={() =>
                                                handleSave(false)
                                            }
                                            onGuestDelete={(changedBooking, deletedGuestId) => {
                                                let newGuests = guests.filter(g => g._id != deletedGuestId);
                                                setGuests(JSON.parse(JSON.stringify(newGuests)));
                                                handleSaveBooking(changedBooking);
                                            }}
                                            allResources={allResources}
                                            allResourceTypes={allResourceTypes}
                                            resourcesInEvent={allResources.filter(r => ([].concat.apply([], r["bookings"].map(b => b?.eventId ?? "")) as Array<any>).includes(event._id?.toString()))}
                                            events={allEvents}
                                            onResourcesChange={(resourcesChanged) => {
                                                setAllResources(JSON.parse(JSON.stringify(resourcesChanged)));
                                                setForceUpdate(forceUpdate + 1);
                                                handleSaveResource(resourcesChanged);
                                            }}
                                            onBookingsChange={(bookingsChanged) => {
                                                let tempBookings = allBookings.filter(b => !bookingsChanged.map(i => i._id).includes(b._id));
                                                tempBookings = [...tempBookings, ...bookingsChanged];
                                                setAllBookings(JSON.parse(JSON.stringify(tempBookings)));
                                                fetchGuests();
                                            }}
                                            onCustomersChange={(customersChanged) => {
                                                let tempCustomers = allCustomers.filter(c => !customersChanged.filter(i => i != undefined && i != null).map(i => i._id).includes(c?._id ?? null));
                                                tempCustomers = [...tempCustomers, ...customersChanged];
                                                setAllCustomers(JSON.parse(JSON.stringify(tempCustomers)));
                                            }}
                                        ></EventGuests>
                                        <br/>
                                    </Tab>
                                : null }
                                <Tab 
                                    eventKey="resourceGuests_info" 
                                    title={t("event.resourceGuests_information")} 
                                    disabled={event._id == undefined || event._id == "" ? true : false}
                                >
                                    <EventResourceGuests
                                        allResources={allResources}
                                        event={event}
                                        allBookings={allBookings}
                                        allDeals={allDeals}
                                        guests={guests}
                                        resourcesInEvent={allResources.filter(r => ([].concat.apply([], r["bookings"].map(b => b?.eventId ?? "")) as Array<any>).includes(event._id?.toString()))}
                                        allCustomers={allCustomers}
                                        onResourcesChange={(resourcesChanged) => {
                                            setAllResources(JSON.parse(JSON.stringify(resourcesChanged)));
                                            setForceUpdate(forceUpdate + 1);
                                        }}
                                        onBookingsChange={(bookingsChanged) => {
                                            setAllBookings(bookingsChanged);
                                            setForceUpdate(forceUpdate + 1);
                                        }}
                                    ></EventResourceGuests>
                                    <br/>
                                </Tab>
                                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                    <Tab 
                                        eventKey="invoicing_info" 
                                        title={t("event.invoicing_information")} 
                                        disabled={event._id == undefined || event._id == "" ? true : false}
                                    >
                                        <EventInvoicing
                                            event={event}
                                            allResources={allResources}
                                            allResourceTypes={allResourceTypes}
                                            allBookings={allBookings}
                                            allCustomers={allCustomers}
                                        ></EventInvoicing>
                                        <br/>
                                    </Tab>
                                : null }
                            </Tabs>
                            <br/>
                            {auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                <Button className="no-print" style={{ float: "right" }} onClick={(evt) => handleSave()}>{event._id == undefined || event._id == "" ? t("event.next") : t("event.save")}</Button>
                            : null}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    )
}


export default EventSingle;